import { useConfig } from "../../../context/ConfigContext";
import { getWhatsappUrl } from "../../../utils/whatsapp";

/**
 * Botón flotante de WhatsApp con el glyph oficial de marca: el aro de la
 * burbuja y el teléfono en verde, el interior de la burbuja en blanco y el
 * afuera transparente. Flota con una sombra suave.
 */
const WhatsAppFAB = () => {
    const { config } = useConfig();

    return (
        <a
            href={getWhatsappUrl(config.pais)}
            target="_blank"
            rel="noreferrer"
            aria-label="Consultanos por WhatsApp"
            style={{
                position: "fixed",
                bottom: "24px",
                right: "24px",
                width: "60px",
                height: "60px",
                display: "block",
                zIndex: 1000,
                cursor: "pointer",
                filter: "drop-shadow(0 4px 12px rgba(0, 0, 0, 0.25))",
            }}
        >
            <svg
                viewBox="0 0 720 720"
                width="60"
                height="60"
                aria-hidden="true"
                style={{ display: "block" }}
            >
                {/* Interior de la burbuja en blanco (contorno exterior relleno). */}
                <path
                    fill="#fff"
                    d="M360,0C161.18,0,0,161.18,0,360c0,65.41,17.45,126.75,47.94,179.61L0,720l187.02-44.21c51.34,28.18,110.28,44.21,172.98,44.21,198.82,0,360-161.18,360-360S558.82,0,360,0Z"
                />
                {/* Aro de la burbuja en verde de marca. */}
                <path
                    fill="#25D366"
                    d="M360,0C161.18,0,0,161.18,0,360c0,65.41,17.45,126.75,47.94,179.61L0,720l187.02-44.21c51.34,28.18,110.28,44.21,172.98,44.21,198.82,0,360-161.18,360-360S558.82,0,360,0ZM360,655.52c-60.17,0-116.13-17.98-162.82-48.87l-110.49,28.14,30.99-105.61c-33.53-47.93-53.2-106.26-53.2-169.19,0-163.21,132.31-295.52,295.52-295.52s295.52,132.31,295.52,295.52-132.31,295.52-295.52,295.52Z"
                />
                {/* Teléfono en verde, adentro de la burbuja. */}
                <path
                    fill="#25D366"
                    d="M444.35,407.52l87.1,41.06c4,1.88,6.56,5.94,6.2,10.34-.94,11.46-5.54,34.43-26.13,55.02-58.12,58.12-162.49-7.64-166.74-10.18-25.67-13.79-50.06-32.24-73.19-55.36-23.12-23.12-41.58-47.52-55.37-73.19-2.55-4.24-68.31-108.61-10.18-166.74,20.59-20.59,43.56-25.19,55.02-26.13,4.41-.36,8.46,2.2,10.34,6.2l41.07,87.1c1.94,4.12,1.09,9.02-2.13,12.24l-30.61,30.61c-6.62,6.62-8.56,16.93-4,25.11,11.17,20.03,26.19,39.32,43.59,57.07,17.75,17.4,37.04,32.43,57.07,43.59,8.18,4.56,18.48,2.62,25.11-4l30.61-30.61c3.22-3.22,8.12-4.08,12.24-2.13Z"
                />
            </svg>
        </a>
    );
};

export default WhatsAppFAB;
